export default __webpack_public_path__ + "static/media/barbell.d4aea79e.svg";